import { AfterViewInit, Component, DebugElement, OnInit, Renderer2 } from '@angular/core';
import { BaseComponent } from '../component-base';
import PerfectScrollbar from 'perfect-scrollbar';
import { notificationDto } from 'src/app/modules/services/license/notification-log/models/notificationDto';
import { NotificationsServicesService } from 'src/app/modules/services/license/notification-log/services/notifications-services.service';
@Component({
  selector: 'app-mainlayout',
  templateUrl: './mainlayout.component.html',
  styleUrls: ['./mainlayout.component.css']
})
export class MainlayoutComponent extends BaseComponent implements AfterViewInit  {
  private ps: any;
  constructor(private renderer: Renderer2,
        private _notificationsServicesService?: NotificationsServicesService
    
  ) {
    super();
    // this.loadJS('assets/myUI/app-assets/vendors/js/vendors.min.js');
    // setTimeout(() => {

    // }, 500); // Delay to ensure DOM is ready

  }
  startHeader: boolean = false;
  changeLanguage(lang) {
    localStorage.setItem('lang', lang);
    location.href = location.href;
  }
  fullName: string;
  ngOnInit(): void {
    
    this.GetNewNotificationLogsCount();
    // this.loadAllScripts();
  }
mynotifications :notificationDto[];
notificationsCount:number;
logout() {
    // CacheService.clearCache();
    // this._authService.isUserLogin$.next(false);
    // this.router.navigate([APP_ROUTER.LOGIN]);
  }

  GetNewNotificationLogsCount() {
    this._notificationsServicesService
      .GetNewNotificationLogs()
      .subscribe((data) => {
        this.mynotifications = data.value;
        this.notificationsCount =  this.mynotifications.length;
      });
  }

  scripts = [
    'assets/tinydash/js/jquery.min.js',
    'assets/tinydash/js/popper.min.js',
    'assets/tinydash/js/moment.min.js',
    'assets/tinydash/js/bootstrap.min.js',
    'assets/tinydash/js/simplebar.min.js',
    'assets/tinydash/js/daterangepicker.js',
    'assets/tinydash/js/jquery.stickOnScroll.js',
    'assets/tinydash/js/tinycolor-min.js',
    'assets/tinydash/js/config.js',
    'assets/tinydash/js/d3.min.js',
    'assets/tinydash/js/topojson.min.js',
    'assets/tinydash/js/datamaps.all.min.js',
    'assets/tinydash/js/datamaps-zoomto.js',
    'assets/tinydash/js/datamaps.custom.js',
    'assets/tinydash/js/Chart.min.js',
    'assets/tinydash/js/CustomJsCodes/CustomJsCodes1.js',
    'assets/tinydash/js/gauge.min.js',
    'assets/tinydash/js/jquery.sparkline.min.js',
    'assets/tinydash/js/apexcharts.min.js',
    'assets/tinydash/js/apexcharts.custom.js',
    'assets/tinydash/js/jquery.mask.min.js',
    'assets/tinydash/js/select2.min.js',
    'assets/tinydash/js/jquery.steps.min.js',
    'assets/tinydash/js/jquery.validate.min.js',
    'assets/tinydash/js/jquery.timepicker.js',
    'assets/tinydash/js/dropzone.min.js',
    'assets/tinydash/js/uppy.min.js',
    'assets/tinydash/js/quill.min.js',
    'assets/tinydash/js/CustomJsCodes/CustomJsCodes2.js',
    'assets/tinydash/js/CustomJsCodes/CustomJsCodes3.js',
    'assets/tinydash/js/apps.js',
    
    
    // 'https://cdnjs.cloudflare.com/ajax/libs/Chart.js/2.7.2/Chart.js'
  ];
  ngAfterViewInit() {
    this.startHeader = true;
    // this.loadAllScripts();
    if (this.currentCulture == 'ar-SA' || this.currentCulture == 'ar') {
      // this.loadCSS('assets/tinydash/css/app-light.css');
      document.body.classList.add('rtl');
      this.loadCSS('assets/tinydash/css/simplebar.css');
      this.loadCSS('assets/tinydash/css/feather.css');
      this.loadCSS('assets/tinydash/css/select2.css');
      this.loadCSS('assets/tinydash/css/dropzone.css');
      this.loadCSS('assets/tinydash/css/uppy.min.css');
      this.loadCSS('assets/tinydash/css/jquery.steps.css');
      this.loadCSS('assets/tinydash/css/jquery.timepicker.css');
      this.loadCSS('assets/tinydash/css/quill.snow.css');
      this.loadCSS('assets/tinydash/css/daterangepicker.css');
      // this.loadCSS('assets/tinydash/css/app-light.css');
      // this.loadCSS('');
      // this.loadCSS('');
      // this.loadCSS('');
      // this.loadCSS('');
      // this.loadCSS('');
      this.loadScript(this.scripts[0])
        .then(() => this.loadScript(this.scripts[1]))
        .then(() => this.loadScript(this.scripts[2]))
        .then(() => this.loadScript(this.scripts[3]))
        .then(() => this.loadScript(this.scripts[4]))
        .then(() => this.loadScript(this.scripts[5]))
        .then(() => this.loadScript(this.scripts[6]))
        .then(() => this.loadScript(this.scripts[7]))
        .then(() => this.loadScript(this.scripts[8]))
        .then(() => this.loadScript(this.scripts[9]))
        .then(() => this.loadScript(this.scripts[10]))
        .then(() => this.loadScript(this.scripts[11]))
        .then(() => this.loadScript(this.scripts[12]))
        .then(() => this.loadScript(this.scripts[13]))
        .then(() => this.loadScript(this.scripts[14]))
        .then(() => this.loadScript(this.scripts[15]))
        .then(() => this.loadScript(this.scripts[16]))
        .then(() => this.loadScript(this.scripts[17]))
        .then(() => this.loadScript(this.scripts[18]))
        .then(() => this.loadScript(this.scripts[19]))
        .then(() => this.loadScript(this.scripts[20]))
        .then(() => this.loadScript(this.scripts[21]))
        .then(() => this.loadScript(this.scripts[22]))
        .then(() => this.loadScript(this.scripts[23]))
        .then(() => this.loadScript(this.scripts[24]))
        .then(() => this.loadScript(this.scripts[25]))
        .then(() => this.loadScript(this.scripts[26]))
        .then(() => this.loadScript(this.scripts[27]))
        .then(() => this.loadScript(this.scripts[28]))
        .then(() => this.loadScript(this.scripts[29]))
        .then(() => this.loadScript(this.scripts[30]))
        // .then(() => this.loadScript(this.scripts[31]))
        .then(() => console.log('All scripts loaded successfully'))
        .catch(error => console.error('Script loading error:', error));

      // this.loadScript('assets/tinydash/js/jquery.min.js');
      // this.loadScript('assets/tinydash/js/popper.min.js');
      // this.loadScript('assets/tinydash/js/moment.min.js');
      // this.loadScript('assets/tinydash/js/bootstrap.min.js');
      // this.loadScript('assets/tinydash/js/simplebar.min.js');
      // this.loadScript('assets/tinydash/js/daterangepicker.js');
      // this.loadScript('assets/tinydash/js/jquery.stickOnScroll.js');
      // this.loadScript('assets/tinydash/js/tinycolor-min.js');
      // this.loadScript('assets/tinydash/js/config.js');
      // this.loadScript('assets/tinydash/js/d3.min.js');
      // this.loadScript('assets/tinydash/js/topojson.min.js');
      // this.loadScript('assets/tinydash/js/datamaps.all.min.js');
      // this.loadScript('assets/tinydash/js/datamaps-zoomto.js');
      // this.loadScript('assets/tinydash/js/datamaps.custom.js');
      // this.loadScript('assets/tinydash/js/Chart.min.js');
      // this.loadScript('assets/tinydash/js/CustomJsCodes/CustomJsCodes1.js');

      // this.loadScript('assets/tinydash/js/gauge.min.js');
      // this.loadScript('assets/tinydash/js/jquery.sparkline.min.js');
      // this.loadScript('assets/tinydash/js/apexcharts.min.js');
      // this.loadScript('assets/tinydash/js/apexcharts.custom.js');
      // this.loadScript('assets/tinydash/js/jquery.mask.min.js');
      // this.loadScript('assets/tinydash/js/select2.min.js');
      // this.loadScript('assets/tinydash/js/jquery.steps.min.js');
      // this.loadScript('assets/tinydash/js/jquery.validate.min.js');
      // this.loadScript('assets/tinydash/js/jquery.timepicker.js');
      // this.loadScript('assets/tinydash/js/dropzone.min.js');
      // this.loadScript('assets/tinydash/js/uppy.min.js');
      // this.loadScript('assets/tinydash/js/quill.min.js');
      // this.loadScript('assets/tinydash/js/CustomJsCodes/CustomJsCodes2.js');
      // this.loadScript('assets/tinydash/js/CustomJsCodes/CustomJsCodes3.js');


      // this.loadScript('assets/tinydash/js/apps.js');

    }
     else {
      document.body.classList.remove('rtl');
      this.loadCSS('assets/tinydash/css/simplebar.css');
      this.loadCSS('assets/tinydash/css/feather.css');
      this.loadCSS('assets/tinydash/css/select2.css');
      this.loadCSS('assets/tinydash/css/dropzone.css');
      this.loadCSS('assets/tinydash/css/uppy.min.css');
      this.loadCSS('assets/tinydash/css/jquery.steps.css');
      this.loadCSS('assets/tinydash/css/jquery.timepicker.css');
      this.loadCSS('assets/tinydash/css/quill.snow.css');
      this.loadCSS('assets/tinydash/css/daterangepicker.css');
      // this.loadCSS('assets/tinydash/css/app-light.css');
      // this.loadScript('assets/tinydash/js/config.js');




      // this.loadScript('assets/tinydash/js/jquery.min.js');
      // this.loadScript('assets/tinydash/js/popper.min.js');
      // this.loadScript('assets/tinydash/js/moment.min.js');
      // this.loadScript('assets/tinydash/js/bootstrap.min.js');
      // this.loadScript('assets/tinydash/js/simplebar.min.js');
      // this.loadScript('assets/tinydash/js/daterangepicker.js');
      // this.loadScript('assets/tinydash/js/jquery.stickOnScroll.js');
      // this.loadScript('assets/tinydash/js/tinycolor-min.js');
      // this.loadScript('assets/tinydash/js/config.js');
      // this.loadScript('assets/tinydash/js/d3.min.js');
      // this.loadScript('assets/tinydash/js/topojson.min.js');
      // this.loadScript('assets/tinydash/js/datamaps.all.min.js');
      // this.loadScript('assets/tinydash/js/datamaps-zoomto.js');
      // this.loadScript('assets/tinydash/js/datamaps.custom.js');
      // this.loadScript('assets/tinydash/js/Chart.min.js');
      // this.loadScript('assets/tinydash/js/CustomJsCodes/CustomJsCodes1.js');

      // this.loadScript('assets/tinydash/js/gauge.min.js');
      // this.loadScript('assets/tinydash/js/jquery.sparkline.min.js');
      // this.loadScript('assets/tinydash/js/apexcharts.min.js');
      // this.loadScript('assets/tinydash/js/apexcharts.custom.js');
      // this.loadScript('assets/tinydash/js/jquery.mask.min.js');
      // this.loadScript('assets/tinydash/js/select2.min.js');
      // this.loadScript('assets/tinydash/js/jquery.steps.min.js');
      // this.loadScript('assets/tinydash/js/jquery.validate.min.js');
      // this.loadScript('assets/tinydash/js/jquery.timepicker.js');
      // this.loadScript('assets/tinydash/js/dropzone.min.js');
      // this.loadScript('assets/tinydash/js/uppy.min.js');
      // this.loadScript('assets/tinydash/js/quill.min.js');
      // this.loadScript('assets/tinydash/js/CustomJsCodes/CustomJsCodes2.js');
      // this.loadScript('assets/tinydash/js/CustomJsCodes/CustomJsCodes3.js');
      // this.loadScript('assets/tinydash/js/apps.js');

      this.loadScript(this.scripts[0])
      .then(() => this.loadScript(this.scripts[1]))
      .then(() => this.loadScript(this.scripts[2]))
      .then(() => this.loadScript(this.scripts[3]))
      .then(() => this.loadScript(this.scripts[4]))
      .then(() => this.loadScript(this.scripts[5]))
      .then(() => this.loadScript(this.scripts[6]))
      .then(() => this.loadScript(this.scripts[7]))
      .then(() => this.loadScript(this.scripts[8]))
      .then(() => this.loadScript(this.scripts[9]))
      .then(() => this.loadScript(this.scripts[10]))
      .then(() => this.loadScript(this.scripts[11]))
      .then(() => this.loadScript(this.scripts[12]))
      .then(() => this.loadScript(this.scripts[13]))
      .then(() => this.loadScript(this.scripts[14]))
      .then(() => this.loadScript(this.scripts[15]))
      .then(() => this.loadScript(this.scripts[16]))
      .then(() => this.loadScript(this.scripts[17]))
      .then(() => this.loadScript(this.scripts[18]))
      .then(() => this.loadScript(this.scripts[19]))
      .then(() => this.loadScript(this.scripts[20]))
      .then(() => this.loadScript(this.scripts[21]))
      .then(() => this.loadScript(this.scripts[22]))
      .then(() => this.loadScript(this.scripts[23]))
      .then(() => this.loadScript(this.scripts[24]))
      .then(() => this.loadScript(this.scripts[25]))
      .then(() => this.loadScript(this.scripts[26]))
      .then(() => this.loadScript(this.scripts[27]))
      .then(() => this.loadScript(this.scripts[28]))
      .then(() => this.loadScript(this.scripts[29]))
      .then(() => this.loadScript(this.scripts[30]))        
      // .then(() => this.loadScript(this.scripts[31]))
      .then(() => console.log('All scripts loaded successfully'))
      .catch(error => console.error('Script loading error:', error));

    }
  }
// List of scripts to load in order

loadScript(src: string): Promise<void> {
  return new Promise((resolve, reject) => {
    // if (!window['$']) {
    //   console.error('❌ jQuery is not loaded yet.');
    //   reject();
    //   return;
    // }

    const script = this.renderer.createElement('script');
    script.src = src;
    script.type = 'text/javascript';
    script.defer = true;

    script.onload = () => {
      console.log(`✅ Loaded: ${src}`);
      resolve();
    };

    script.onerror = () => {
      console.error(`❌ Failed to load: ${src}`);
      reject();
    };

    this.renderer.appendChild(document.body, script);
  });
}

  // Load scripts in order
  loadAllScripts() {
    try {
      this.loadScript(this.scripts[0])
      .then(() => this.loadScript(this.scripts[1]))
      .then(() => this.loadScript(this.scripts[2]))
      .then(() => this.loadScript(this.scripts[3]))
      .then(() => console.log('All scripts loaded successfully'))
      .catch(error => console.error('Script loading error:', error));



      // this.loadScript('assets/myUI/js/jquery.js');
      // setTimeout(() => {
      //   this.loadScript('assets/myUI/app-assets/vendors/js/vendors.min.js');
      // }, 100); // Delay to ensure DOM is ready
      // setTimeout(() => {
      //   this.loadScript('assets/myUI/app-assets/js/core/app-menu.js');
      //   // this.loadScript('assets/myUI/app-assets/js/core/app.js');

      // }, 300); // Delay to ensure DOM is ready
      // setTimeout(() => {
      //   //this.loadScript('assets/myUI/app-assets/js/core/app-menu.js');
      //   this.loadScript('assets/myUI/app-assets/js/core/app.js');
      // }, 700); // Delay to ensure DOM is ready
  
      window.onload = () => {
        console.log('✅ All scripts and assets have loaded.');
      };
    } catch (error) {
      console.error('❌ Error loading scripts:', error);
    }


  }
  ngOnDestroy() {
    // Cleanup Perfect Scrollbar when component is destroyed
    if (this.ps) {
      this.ps.destroy();
    }
  }

  addInlineScript(code: string): void {
    const script = document.createElement('script');
    script.type = 'text/javascript';
    script.text = code;
    document.body.appendChild(script);
  }
  private loadCSS(href: string): void {
    const link = this.renderer.createElement('link');
    link.rel = 'stylesheet';
    link.href = href;
    this.renderer.appendChild(document.head, link);
  }

  // private loadJS(src: string): void {

  //   const script = this.renderer.createElement('script');
  //   script.type = 'text/javascript';
  //   script.src = src;
  //   script.defer = true;
  //   script.onload = () => {
  //     console.log(`✅ Script loaded successfully: ${src}`);
  //   };

  //   script.onerror = () => {
  //     console.error(`❌ Failed to load script: ${src}`);
  //   };
  //   this.renderer.appendChild(document.body, script);
  // }

  

}
